"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabSourcesSelector = void 0;
var _getSources = require("@studio/sources/getSources");
var _Sources = require("@studio/constants/Sources");
var _reselect = require("reselect");
var _sources = require("../utils/sources");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function selectTab(state) {
  return state.tabs.currentTab;
}
function selectFeaturedPresenter(state) {
  return state.featuredPresenter;
}
function selectAttendeeMuteStatus(state) {
  return state.attendeeMuteStatus;
}
function selectBroadcastSources(state) {
  return state.broadcastSources.sources;
}

/**
 * @param {Array} sources
 * @param {Array} sourceTypes
 */
function filterSources(sources, sourceTypes) {
  return sources === null || sources === void 0 ? void 0 : sources.filter(function (source) {
    return sourceTypes.includes(source.type);
  });
}

/**
 * @param {Array} sources
 * @param {string} featuredPresenter
 */
function addFeaturedPresenter(sources, featuredPresenter) {
  var featuredPresenterIndex = sources === null || sources === void 0 ? void 0 : sources.findIndex(function (source) {
    return source.type === _Sources.CAMERA_PRESENTER && source._id === featuredPresenter;
  });
  if (featuredPresenterIndex > -1) {
    // We have a featured presenter
    sources[featuredPresenterIndex].featured = true;
  }
  return sources;
}
var tabSourcesSelector = exports.tabSourcesSelector = (0, _reselect.createSelector)([selectTab, selectBroadcastSources, selectAttendeeMuteStatus, selectFeaturedPresenter], function (currentTab, sources, attendeeMuteStatus, featuredPresenter) {
  if (currentTab === 'speakers') {
    var presenterSources = filterSources(sources, [_Sources.SCREEN_PRESENTER, _Sources.CAMERA_PRESENTER]).map(function (source) {
      var sourceValue = (0, _getSources.getSourceValue)(source);
      return _objectSpread(_objectSpread({}, source), {}, {
        muted: !!attendeeMuteStatus[sourceValue]
      });
    });
    var orderedPresenterSources = (0, _sources.orderSources)(presenterSources);

    // Screen Share source should always be at the beginning of the source list items
    var combinedSources = filterSources(orderedPresenterSources, [_Sources.SCREEN_PRESENTER]).concat(filterSources(orderedPresenterSources, [_Sources.CAMERA_PRESENTER]));
    return addFeaturedPresenter(combinedSources, featuredPresenter);
  }
  if (currentTab === _Sources.MEDIA) {
    var mediaSources = filterSources(sources, [_Sources.MEDIA, _Sources.AUDIO_FILE, _Sources.VIDEO_FILE, _Sources.IMAGE_FILE, _Sources.PDF_FILE]);
    return (0, _sources.orderSources)(mediaSources);
  }
  return filterSources(sources, [currentTab]);
});